import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Default config when API is not available
const DEFAULT_CONFIG = {
  payments_enabled: false,
  founding_year_2026: true,
  show_subscription_prices: false
};

const ConfigContext = createContext(DEFAULT_CONFIG);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await axios.get(`${API_URL}/config/public`);
      setConfig(response.data);
    } catch (error) {
      console.log('Using default config');
      // Keep default config if API fails
    } finally {
      setLoading(false);
    }
  };

  const refreshConfig = () => {
    fetchConfig();
  };

  return (
    <ConfigContext.Provider value={{ ...config, loading, refreshConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    return DEFAULT_CONFIG;
  }
  return context;
};

// Helper hook to check if payments are enabled
export const usePaymentsEnabled = () => {
  const { payments_enabled } = useConfig();
  return payments_enabled;
};

// Helper hook to check if we're in founding year mode
export const useFoundingYear = () => {
  const { founding_year_2026 } = useConfig();
  return founding_year_2026;
};

// Helper hook to check if prices should be shown
export const useShowPrices = () => {
  const { show_subscription_prices, payments_enabled } = useConfig();
  return show_subscription_prices || payments_enabled;
};

export default ConfigContext;
